import styled from 'styled-components';

import CircularProgress from 'components/shared/CircularProgress';
import useIsMobile from 'hooks/useIsMobile';
import { colors } from 'styles/theme/colors';
import ChartIconLarge from 'svg/ChartIconLarge';

type Props = {
  children: React.ReactNode;
  hasData?: boolean;
  loading?: boolean;
  header: React.JSX.Element;
};

export default function MetricDetailContainer(props: Props) {
  const { children, hasData = true, loading = false, header, ...rest } = props;

  const isMobile = useIsMobile();

  return (
    <Container {...rest}>
      {header}
      {!isMobile && (
        <>
          {loading ? (
            <SpinnerContainer>
              <CircularProgress color={colors.blue100} />
            </SpinnerContainer>
          ) : (
            <MetricContent>
              {hasData ? (
                children
              ) : (
                <EmptyState>
                  <ChartIconLarge color={colors.blue100} />
                  <EmptyText>No data to show for the selected date range or filters</EmptyText>
                </EmptyState>
              )}
            </MetricContent>
          )}
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  height: '100%';
  max-width: 1280px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black10};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 24px 24px 24px 24px;
  margin: 0 auto 0 auto;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.desktop} {
    height: 360px;
    padding-bottom: 8px;
  }
`;

const EmptyText = styled.p`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 16px;
  font-weight: normal;
  margin-top: 16px;
  text-align: center;
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

const MetricContent = styled.div`
  min-height: 200px;
  margin-top: 24px;
  width: 100%;
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const SpinnerContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
